export default __webpack_public_path__ + "static/media/command.5d1edb6b.svg";